import { render, staticRenderFns } from "./budget-program.vue?vue&type=template&id=d90da200&scoped=true&"
import script from "./budget-program.vue?vue&type=script&lang=ts&"
export * from "./budget-program.vue?vue&type=script&lang=ts&"
import style0 from "./budget-program.vue?vue&type=style&index=0&id=d90da200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90da200",
  null
  
)

export default component.exports